
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import Transition from './common/Transition'; 

const CdiRenewalSubOptionsDialog = ({
  open,
  onClose, 
  onBackToMainCdiOptions, 
  onProlongTestPeriod, 
  onAcceptCollaborateur,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose} 
      fullWidth
      maxWidth="xs"
      TransitionComponent={Transition}
      keepMounted
      slotProps={{ paper: {
        sx: {
          borderRadius: 6,
          background: 'rgba(255, 255, 255, 0.75)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          overflow: 'hidden',
        }
      } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          fontFamily: `'Orbitron', 'Segoe UI', sans-serif`,
          fontWeight: 700,
          fontSize: '1.3rem',
          textTransform: 'uppercase',
          letterSpacing: '0.8px',
          color: '#0f172a',
          pt: 4,
        }}
      >
        Options de Renouvellement CDI
      </DialogTitle>

      <DialogContent sx={{ px: 4, pt: 2, pb: 3 }}>
        <Typography
          variant="body1"
          align="center"
          sx={{
            fontFamily: `'Segoe UI', Roboto, sans-serif`,
            color: '#334155',
            fontSize: '1rem',
            letterSpacing: '0.3px',
            mb: 2,
          }}
        >
          Comment souhaitez-vous gérer la période de test du CDI ?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          px: 3,
          pb: 4,
          flexDirection: 'column', 
        }}
      >
        <Button
          variant="contained"
          onClick={onProlongTestPeriod}
          sx={{
            width: '100%',
            maxWidth: '250px',
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1.5,
            background: 'linear-gradient(90deg, #3b82f6, #03407b)',
            color: '#fff',
            boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
            '&:hover': {
              background: 'linear-gradient(90deg, #2563eb, #02357a)',
            },
          }}
        >
          Prolonger la période de test
        </Button>
        <Button
          variant="contained"
          onClick={onAcceptCollaborateur}
          sx={{
            width: '100%',
            maxWidth: '250px',
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1.5,
            background: 'linear-gradient(90deg, #10b981, #059669)',
            color: '#fff',
            boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
            '&:hover': {
              background: 'linear-gradient(90deg, #059669, #047857)',
            },
          }}
        >
          Accepter ce collaborateur (CDI définitif)
        </Button>
        <Button
          variant="outlined"
          onClick={onBackToMainCdiOptions}
          sx={{
            width: '100%',
            maxWidth: '250px',
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1.5,
            color: '#64748b',
            borderColor: '#64748b',
            '&:hover': {
              background: '#f1f5f9',
              borderColor: '#475569',
            },
            mt: 1, 
          }}
        >
          Retour
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CdiRenewalSubOptionsDialog;